export const LOGO_URL = "/ping.png"
export const BACKGROUND_IMG = "https://nmcprofessionals.org.uk/uploads/assets/background.jpg"
